
// This file provides backward compatibility for components still importing from '@/hooks/use-toast'
import { toastService } from "@/utils/toastService";

interface ToastProps {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

// Create a backward-compatible interface for the useToast hook
export const useToast = () => ({
  toast: (props: ToastProps) => {
    if (props.variant === 'destructive') {
      return toastService.error(props.description || props.title || '');
    }
    return toastService.info(props.description || props.title || '');
  },
  dismiss: toastService.dismiss
});

// Also export a simple toast function for direct use
export const toast = (props: ToastProps) => {
  if (props.variant === 'destructive') {
    return toastService.error(props.description || props.title || '');
  }
  return toastService.info(props.description || props.title || '');
};
